import React from "react";
import {
  ServicesBanner,
  ServicesFaqSection,
  ServicesList,
  ServicesWhySection,
} from "../sections/services";
import HomeCtaBannerSection from "../sections/home/HomeCtaBannerSection";

const Services: React.FC = () => {
  return (
    <div>
      <ServicesBanner />
      <ServicesList />
      <ServicesWhySection />
      <ServicesFaqSection />
      <HomeCtaBannerSection />
    </div>
  );
};

export default Services;
